module.exports = "https://bicocca-network.servercdn.it/static/img/crowdfunding_guida.png?3de7de73df813e953699671d0452c07d";